import 'angular';

import '../../app-lite/imports/imports.module';

import { ImportsStates } from './imports.states.ajs';

angular.module('workshop.imports', [
  'app-lite.imports'
]).config(ImportsStates);
